import { getApiBase } from '@/lib/api-base';
import { fetchWebtokenHeadless } from '@/store/auth-helper';

/**
 * Asks the server to stop a Clu turn: the one `clientTurnId` names, or with
 * no turn id, the one running in `conversationId`. A turn keeps running on
 * the server when its stream closes, so this is what ends it. Best effort.
 */
export async function stopServerTurn(
  conversationId: string | null,
  clientTurnId: string | null
): Promise<void> {
  if (!conversationId && !clientTurnId) return;
  try {
    const token = await fetchWebtokenHeadless();
    await fetch(`${getApiBase()}/api/v1/agent/chat/stop`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        conversation_id: conversationId,
        client_turn_id: clientTurnId,
      }),
    });
  } catch {
    // The turn runs to its end and its reply is saved.
  }
}
